<script>
import { formatSEODate } from '../../../libs/datetime'
import { getPageMetadata } from '../../../libs/metadata/'
import SearchFilterLabelMixin from '../../../mixins/search/label'

export default {
  computed: {
    /**
     * Description
     */
    metaDescription() {
      return this.$t('search.metaDistrictDescription', {
        district: this.titleDistrict,
        numberOfJobs: this.paramTotal,
      })
    },
    /**
     * Keyword
     */
    metaKeyword() {
      return this.$t('search.metaKeywordDistrict')
    },
    /**
     * Title
     */
    metaTitle() {
      return this.$t('search.metaDistrictTitle', {
        district: this.titleDistrict,
        numberOfJobs: this.paramTotal,
        searchDate: this.searchDate,
      })
    },
    searchDate() {
      const timestamp = this.paramTimestamp || Date.now()
      const locale = this.currentLocale.code
      return formatSEODate(new Date(timestamp), locale)
    },

    titleDistrict() {
      return this.getDisplayDistrictsLabel(this.filterQueryObject.district)
    },
  },
  head() {
    return getPageMetadata(this.metaTitle, this.metaDescription, null, this.metaKeyword)
  },
  mixins: [SearchFilterLabelMixin],
  props: {
    filterQueryObject: {
      default: () => ({}),
      type: Object,
    },
    paramTimestamp: {
      default: 0,
      type: Number,
    },
    /**
     * Total number of jobs matching search param
     */
    paramTotal: {
      default: 0,
      type: Number,
    },
  },
  // Handle to empty single root
  render(createElement) {
    return null
  },
}
</script>
